import * as React from "react";
import { Check } from "lucide-react";

type Step = "password" | "ktpAddress" | "email" | "phone" | "photos";

const STEP_LABELS: Record<Step, string> = {
  password: "1",
  ktpAddress: "2",
  email: "3",
  phone: "4",
  photos: "5",
};

interface StepProgressProps {
  steps: Step[];
  currentStepIndex: number;
}

export function StepProgress({ steps, currentStepIndex }: StepProgressProps) {
  return (
    <div className="flex items-center justify-center mb-8 gap-2 flex-wrap">
      {steps.map((step, idx) => {
        const isCompleted = idx < currentStepIndex;
        const isCurrent = idx === currentStepIndex;

        return (
          <React.Fragment key={step}>
            <div className={`flex items-center ${isCurrent || isCompleted ? "text-primary" : "text-muted-foreground"}`}>
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${
                  isCompleted
                    ? "bg-primary text-primary-foreground border-primary"
                    : isCurrent
                    ? "bg-primary text-primary-foreground border-primary"
                    : "border-muted-foreground"
                }`}
              >
                {isCompleted ? <Check className="h-4 w-4" /> : STEP_LABELS[step]}
              </div>
            </div>
            {idx < steps.length - 1 && (
              <div className={`w-12 h-0.5 ${idx < currentStepIndex ? "bg-primary" : "bg-muted"}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
